import styled from 'styled-components'

const StyledProfile = styled.div`
  input {
    height: 40px;
    padding: 0 12px;
    width: 100%;
    color: ${({ theme }) => theme.colors.gray[800]};
    border: 1px solid ${({ theme }) => theme.colors.gray[300]};
    background-color: ${({ theme }) => theme.colors.background};
    border-radius: 4px;
    transition: 0.2s;
    outline: none;

    &::placeholder {
      color: ${({ theme }) => theme.colors.gray[300]};
      user-select: none;
    }

    &:focus {
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.green[100]};
      border: 1px solid ${({ theme }) => theme.colors.green[500]};
    }

    &:disabled {
      background-color: ${({ theme }) => theme.colors.gray[100]};
      border: 1px solid ${({ theme }) => theme.colors.gray[100]};
      color: ${({ theme }) => theme.colors.gray[500]};
      cursor: not-allowed;
      user-select: none;
    }
  }

  button {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s;
    border-radius: 6px;
    padding: 0 12px;
    font-weight: 600;
    user-select: none;
    border: 1px solid ${({ theme }) => theme.colors.gray[300]};
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.gray[600]};

    span {
      position: relative;
      top: 1px;
    }

    svg:not(.spinner-icon) {
      height: 18px;
      margin-right: 8px;
    }

    &:hover {
      cursor: pointer;
      background-color: ${({ theme }) => theme.colors.gray[100]};
    }
  }

  .form-container {
    display: grid;
    grid-gap: 20px;
  }

  .input-heading {
    .input-label {
      font-family: ${({ theme }) => theme.fonts.nunito};
      color: ${({ theme }) => theme.colors.gray[600]};
      font-size: 15px;
      user-select: none;
      font-weight: 600;
    }
  }
`

export default StyledProfile
